import React from 'react'
import { Button, Container } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { AGENTS_PORTAL } from '../api/constants';
import { Link } from 'react-router-dom';

function CreateAccountCTA() {
   const navigate = useNavigate();

  const handleCreateAccount = () => {
    navigate('/become-an-agent-create-an-account');
  };
  return (
    <>
     <div className="connect-agent-cta create-account common-padding">
      <Container>
        <div className='connect-agent-cta-wrap flex-column align-items-center'>
          <div className='text-wrap mx-auto d-flex flex-column justify-content-center align-items-center text-center'>
            <h2>Start connecting with home shoppers<br/> on Real Estate and Trulia</h2>
            <p className='w-100 w-md-50'>Lorem Ipsum is simply dummy text of the printing
and typesetting industry. Lorem Ipsum has been the industry's standard
dummy text ever since the 1500s,</p>
          </div>
          <Link to={`${AGENTS_PORTAL}/auth/register`} target="_blank" className="custom-bttn style-3">Create an Account</Link>
        </div>
      </Container>
     </div>
    </>
  )
}
export default CreateAccountCTA